import { useState, useEffect } from "react";
// import { useFocusEffect } from "@react-navigation/native";

const useOnMount = (...api) => {
  const [data, setData] = useState();
  const [isLoading, setLoading] = useState(true);
  const [error, setError] = useState();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const fetchedData = await Promise.all(api.map((call) => call()));
        setData(fetchedData);
      } catch (e) {
        setError(e);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return { isLoading, data, error };
};

export default useOnMount;
